import React from "react";

export default function Mensaje131001() {
  return (
    <>
      <p>
        <h6>13 de octubre de 2001</h6>
        <br />
        <p>
          Amados hijos: <br />
          Os pido que renovéis vuestras vidas. <strong>
            ¡Adoren a Dios!
          </strong>{" "}
          por sobre todas las cosas. No se puede conocer El Divino Amor si no os
          disponéis desde lo profundo del alma.
          <br />
          En estos días veo corazones tristes y caras afligidas. ¡Animaos mis
          hijitos!. La Madre del Señor está con vosotros.
          <br />
          <strong>Oren a Dios con confianza, oren cada día más,</strong> y vivan
          lo que oran.
          <br />
          Oren y digan:
          <br />
          <strong>
            <i>
              "Señor mío, y Dios mío <br />
              ven a mi corazón <br />
              renueva en mí la fe.
              <br />
              Abre mi corazón para recibir <br />
              y para dar.
              <br />
              Lléname de tu amor".
              <br />
            </i>
          </strong>
          Benditos sean.
          <br />
          Os amo cada día más
          <br />
          Amén. Amén. Amén.
        </p>
      </p>
    </>
  );
}
